import React from 'react';
import { Link } from 'react-router-dom';

const GetInvolved = () => {
  const ways = [
    {
      icon: "🤝",
      title: "Partner with us",
      description: "Collaborate in community initiatives and development programs"
    },
    {
      icon: "🙋",
      title: "Volunteer",
      description: "Join our awareness and empowerment programs"
    },
    {
      icon: "💼",
      title: "Support our projects",
      description: "Contribute to our outreach activities and community work"
    }
  ];

  return (
    <section className="get-involved" id="get-involved">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Get Involved</h2>
          <p className="section-subtitle">Community transformation requires collaboration</p>
        </div>
        <div className="involved-content">
          <p className="involved-intro">
            You can support CAEI's mission in several ways:
          </p>
          <div className="involved-grid">
            {ways.map((way, index) => (
              <div className="involved-card" key={index}>
                <div className="involved-icon">{way.icon}</div>
                <h3>{way.title}</h3>
                <p>{way.description}</p>
              </div>
            ))}
          </div>
          <div className="involved-cta">
            <p className="involved-message">
              Together, we can build stronger and more empowered communities.
            </p>
            <Link to="/contact" className="btn btn-primary btn-large">Contact Us Today</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetInvolved;
